<template>
  <modal name="modal-edit-note" height="auto" :width="560"
    :scrollable="true" :clickToClose="false" @closed="$emit('input', false)">
    <div class="modal-head mb-3">
      <h4>EDIT NOTE</h4>
      <a href="javascript:;" class="close" @click="closeModal"></a>
    </div>
    <form method="post" @submit.prevent="doSave">
      <div class="form-group">
        <label for="title">Title <span class="text-danger">*</span></label>
        <input type="text" name="title" id="title" ref="inputTitle"
               :class="{'form-control': true, 'is-invalid': errors.has('name')}"
               v-validate.disable="{ required: true }"
               v-model="title">
        <div class="invalid-feedback">{{ errors.first('title') }}</div>
      </div>
      <div class="form-group" :class="{'d-none': hideClientSelector}">
        <label for="client_id">Client</label>
        <select name="client_id" id="client_id"
                :class="{'form-control': true, 'is-invalid': errors.has('client_id')}"
                v-model="client_id">
          <option value="">- Select -</option>
          <option v-for="client in CLIENTS" :key="client.id" :value="client.id">
            {{ client.name }}
          </option>
        </select>
        <div class="invalid-feedback">{{ errors.first('client_id') }}</div>
      </div>
      <div class="form-group">
        <label>Content <span class="text-danger">*</span></label>
        <editor :api-key="tinyApiKey" :init="tinyOpts" v-model="content"></editor>
        <div class="invalid-feedback">{{ errors.first('content') }}</div>
      </div>
      <!-- <div class="form-group">
        <label for="content">Content <span class="text-danger">*</span></label>
        <textarea name="content" id="content"  ref="inputContent"
                  :class="{'form-control': true, 'is-invalid': errors.has('content')}"
                  v-validate.disable="{ required: true }"
                  v-model="content"></textarea>
        <div class="invalid-feedback">{{ errors.first('content') }}</div>
      </div>
      <div class="form-group">
        <label for="password">Password</label>
        <input type="password" name="password" id="password" ref="inputPassword"
               :class="{'form-control': true, 'is-invalid': errors.has('password')}"
               v-model="password">
        <div class="invalid-feedback">{{ errors.first('password') }}</div>
      </div>
      <div class="form-group" v-if="password != ''">
        <label for="password_confirmation">Retype Password <span class="text-danger">*</span></label>
        <input type="password" name="password_confirmation" id="password_confirmation"
               :class="{'form-control': true, 'is-invalid': errors.has('password_confirmation')}"
               v-validate.disable="{ required: true }"
               v-model="password_confirmation">
        <div class="invalid-feedback">{{ errors.first('password_confirmation') }}</div>
      </div> -->
      <div class="pt-2 btns btns-2">
        <beat-loader v-if="state == 'saving'"></beat-loader>
        <template v-else>
          <button type="submit" class="btn btn-outline-black mr-2">Save Changes</button>
          <button type="button" class="btn btn-outline-secondary" @click="closeModal">Cancel</button>
        </template>
      </div>
    </form>
  </modal>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import Editor from '@tinymce/tinymce-vue'
import BeatLoader from 'vue-spinner/src/BeatLoader'
import ServiceNote from '@/services/note'

export default {
  components: {
    BeatLoader,
    Editor
  },
  data () {
    return {
      state: '',
      title: '',
      client_id: '',
      content: '',
      password: '',
      password_confirmation: '',
      hideClientSelector: false
    }
  },
  props: ['value', 'note', 'clientId'],
  computed: {
    ...mapGetters(['CLIENTS']),
    ...mapState({
      tinyApiKey: state => state.option.tinyApiKey,
      tinyOpts: state => state.option.tinyOpts
    })
  },
  watch: {
    note: 'init',
    clientId: 'init',
    value ( newVal ) {
      let self = this;
      if ( newVal ) {
        this.$modal.show('modal-edit-note', {});
        setTimeout(() => {
          self.$refs.inputTitle.focus();
        }, 200);
      }
    }
  },
  mounted () {
    this.init();
  },
  methods: {
    init () {
      let self = this;
      self.hideClientSelector = typeof self.clientId != 'undefined' && self.clientId;
      if ( !self.note ) {
        return;
      }
      self.title = self.note.title;
      self.content = self.note.content;
      self.client_id = self.note.client_id;
      if(self.client_id == null)
        self.client_id = '';
      self.password = '';
      self.password_confirmation = '';
    },
    closeModal () {
      this.$modal.hide('modal-edit-note');
    },
    doSave ( ) {
      let self = this;

      if ( self.state == 'saving' ) {
        return;
      }

      let postData = {};

      if ( self.title != self.note.title )
        postData.title = self.title;

      if ( self.content != self.note.content )
        postData.content = self.content;

      if ( self.client_id != self.note.client_id )
        postData.client_id = self.client_id;

      if ( self.password ) {
        postData.password = self.password;
        postData.password_confirmation = self.password_confirmation;
      }

      self.state = 'saving';
      ServiceNote.save(self.note.id, postData, note => {
        self.state = '';
        self.$notify({
          type: 'success',
          text: 'Note updated successfully.'
        });
        self.$emit('note-saved', note);
        self.closeModal();
      }, () => {
        self.state = '';
      });
    }
  }
}
</script>
